<app-fil-ariane-v2></app-fil-ariane-v2>
<div class="maincontainer background-color pb-4">
    <div class="mt-4">
        <app-event-header></app-event-header>
        <app-event-edit-form></app-event-edit-form>
    </div>
</div>